/* Angular Modules */
import { NgModule }                 from '@angular/core';
import { CommonModule }             from '@angular/common';
import { RouterModule }             from '@angular/router';
import { FormsModule }              from '@angular/forms';

/* External Modules */
import { SidebarModule }            from 'ng-sidebar';

/* Local Modules */
import { CoreModule }               from '../core/core.module';

/* Local Components */
import { LayoutComponent }          from './layout.component';

/* Local Routes */
import { LayoutRoutes }             from './layout.routing';


@NgModule({
  declarations: [
    LayoutComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
	  CoreModule,
	  RouterModule.forChild(LayoutRoutes),
    SidebarModule.forRoot()
  ]
})
export class LayoutModule { }
